//страны бирж
export enum CountryExchange {
  RU = 'ru',
  US = 'us',

}

//(это ключи для мультиязычности в файле i18.ts)
export const CountryExchangeLabel: Record<keyof typeof CountryExchange, string> = {
  RU: "CountryExchangeLabelRu",
  US: "CountryExchangeLabelUS",

}